const KEY = 'sml.referralCode';
const TTL_DAYS = 30;
const TTL_MS = TTL_DAYS * 24 * 60 * 60 * 1000;

interface StoredReferral {
  code: string;
  capturedAt: number;
}

export function getReferralCode(): string | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw === null) {
      return null;
    }
    const parsed = JSON.parse(raw) as StoredReferral;
    if (Date.now() - parsed.capturedAt > TTL_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return parsed.code;
  } catch {
    try {
      localStorage.removeItem(KEY);
    } catch {
      // ignore
    }
    return null;
  }
}

export function setReferralCode(code: string): void {
  if (getReferralCode() !== null) {
    return;
  }
  try {
    const payload: StoredReferral = { code, capturedAt: Date.now() };
    localStorage.setItem(KEY, JSON.stringify(payload));
  } catch {
    // localStorage disabled — silent no-op
  }
}

export function clearReferralCode(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
